import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { portTransitTimesApi } from '../api/portTransitTimes.api';
import type { PortTransitTimeRow } from '../interfaces/portTransitTimes.interface';

interface UsePortTransitTimesResult {
  data: PortTransitTimeRow[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

export function usePortTransitTimes(): UsePortTransitTimesResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<PortTransitTimeRow[]>({
    queryKey: ['dashboard', 'port-transit-times', selectedCompanyId, direction],
    queryFn: () => portTransitTimesApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
